import React from 'react';
import { Form, FormGroup, Col, Row, Button, InputGroup, FormControl, ControlLabel, Checkbox, Glyphicon, Modal } from 'react-bootstrap';
import LoadingSpinner from '../../../LoadingSpinner';

class GrantsModules extends React.Component {
    constructor(props) {
        super(props);
    }

    setCheckboxClassName(grant) {
        if (this.props.activeGrants?.find(_grant => _grant.Type == grant.Type) &&
            !this.props.roleGrants?.find(_grant => _grant.Type == grant.Type)) return 'isAdded'

        if (this.props.roleGrants?.find(_grant => _grant.Type == grant.Type) &&
            !this.props.activeGrants?.find(_grant => _grant.Type == grant.Type)) return 'isRemoved'

        return ''
    }

    setCheckboxChecked(grant) {
        if (this.props.activeGrants?.find(_grant => _grant.Type == grant.Type && _grant.isRemoved)) return false
        if (this.props.activeGrants?.find(_grant => _grant.Type == grant.Type)) return true
        return false
    }

    render() {
        let disabled = this.props.disabled;
        return (
            <fieldset className="myfieldset smaller-inputs margin-top-10">
                <legend className="mylegend">Grants</legend>
                <Row className="grantsList">
                    {this.props.selectableGrantModules?.length == 0 ?
                        (<LoadingSpinner isLoading={true} />) :
                        (
                            this.props.selectableGrantModules.map(module => (
                                <Col key={module.ModuleName} md={5} lg={3}>
                                    <h4>{module.ModuleName}</h4>
                                    {module.Grants.map(grant => (
                                        <FormGroup key={grant.Type} className={this.setCheckboxClassName(grant)}>
                                            <InputGroup bsSize="sm">
                                                <InputGroup.Addon>{grant.Name}</InputGroup.Addon>
                                                <Checkbox
                                                    disabled={disabled}
                                                    checked={this.setCheckboxChecked(grant)}
                                                    onChange={(e) => this.props.toggleRoleGrant(e, grant)}
                                                />
                                            </InputGroup>
                                        </FormGroup>
                                    ))}
                                </Col>
                            ))
                        )
                    }
                </Row>
            </fieldset>         
        )
    }
}

export default GrantsModules;